import { Exclude, Transform } from 'class-transformer';

import { booleanTransform, dateTransform } from '../utils/helper';

export class Attach {
	id!: number;
	entity!: string;
	eid!: number;
	extension?: string;
	filename!: string;
	fspath!: string;
	size?: number;
	uid?: number;
	type?: string;
	@Transform(dateTransform)
	uploaddate!: Date;

	@Exclude()
	previewurl: any;

	opaqueid?: string;
	@Transform(dateTransform)
	expirydate?: Date;
	@Transform(booleanTransform)
	archived?: boolean;
	@Transform(booleanTransform)
	valid?: boolean;
}

export enum AttachSize {
	LG = 'lg',
	MD = 'md',
	XS = 'xs',
}